import { createSlice, current } from '@reduxjs/toolkit';




const initialState = {
  purchaseDate:[]
};

export const orderPurchaseDate = createSlice({
  name: 'purchase',
  initialState,
  reducers: {
    setPurchaseDate: (state, { payload }) => {
     
      state.purchaseDate = [...payload];
    },
    
   
    clearPurchaseState: (state) => {
      state=initialState
    }
  }
});

export const { setPurchaseDate, clearPurchaseState } = orderPurchaseDate.actions;

export const purchaseDateData = (state) => state.purchase;


export default orderPurchaseDate.reducer;
